import { mapActions } from 'vuex';
import showShareAlert from '@f/share';
import shareTip from '@f/shareTip';
import QRCode from 'qrcode';
import {
  isHllApp,
  isWeixinBrowser,
  isWxMiniProgram,
  parseURL,
  parseQuery,
  stringifyQuery,
  getUrlParam
} from '@/utils';
import {
  isXlMiniProgram,
  isXlUserApp,
  lowXlVersionUserApp
} from '@/utils/judgeEnv';

function parseQrcodePosition(positionType) {
  switch (positionType) {
    case 'center':
      return {
        top: 266,
        left: 242
      };
    case 'rightbottom':
      return {
        top: 756,
        left: 426
      };
  }
}

export default {
  computed: {},
  methods: {
    ...mapActions('app/inviteEarnCoupon/inviter', [
      'getShareCode',
      'getWxaQRCode'
    ]),
    url(mode, shareCode) {
      let loc = location;
      const urlObj = parseURL(loc.href);
      const queryObj = parseQuery();
      const { tpl, u, bl, code } = queryObj;
      const newQueryObj = { tpl, u, bl, code };
      newQueryObj.fromShare = 'true';
      if (mode === 'invite' && shareCode) {
        newQueryObj['invitation_uuid'] = shareCode;
      }
      urlObj.search = `?${stringifyQuery(newQueryObj)}`;
      urlObj.hash = '#/invitee';
      const urlString = urlObj.toString();
      return urlString;
    },
    async getLocalQRCode(link) {
      try {
        const localQRCode = await QRCode.toDataURL(link, {
          errorCorrectionLevel: 'L',
          margin: 0
        });
        return localQRCode;
      } catch (err) {
        console.error(err);
      }
    },
    /**
     * 调起分享 options.shareMode = normal|invite
     * @param {Object} options
     */
    async launchShare(options = {}) {
      if (!isHllApp() && !isWeixinBrowser() && !isWxMiniProgram()) {
        return this.$hll.toast('请在微信里进行分享~');
      }
      const shareMode = options.shareMode || 'invite';
      let url;
      if (shareMode === 'invite') {
        // 如果是邀请分享需要获取 shareCode
        try {
          const shareCode = await this.getShareCode();
          url = this.url(shareMode, shareCode);
        } catch (error) {
          throw error;
        }
      } else {
        url = this.url();
      }
      console.log('share url', url);
      let localQRCode;
      let wxaQRCode;
      let qrcodePositionObj = {};
      if (options.isOpenFaceShare) {
        if (isXlUserApp() || isXlMiniProgram()) {
          try {
            wxaQRCode = await this.getWxaQRCode({
              url,
              token: getUrlParam('token')
            });
          } catch (err) {
            this.$hll.toast('去发送给好友吧');
            console.warn('生成小程序 shareCode 出错', err);
            localQRCode = await this.getLocalQRCode(url);
          }
        } else {
          localQRCode = await this.getLocalQRCode(url);
        }
        qrcodePositionObj = parseQrcodePosition(options.qrcodePosition);
      }
      const wxmpConfig = {
        miniprogram_id: 'gh_53d3b8626252',
        miniprogram_path: `pages/index/index?webview=${encodeURIComponent(url)}`
      };
      const config = {
        link: url,
        qrcodeUrl: wxaQRCode || localQRCode,
        ...wxmpConfig,
        posterBtn: {
          text: '面对面邀请',
          icon: require('@/components/templates/assets/images/poster_btn.png')
        },
        qrCodeWidth: 266,
        qrcodeLeft: qrcodePositionObj.left,
        qrcodeTop: qrcodePositionObj.top,
        ...options
      };
      return new Promise(resolve => {
        showShareAlert({
          config,
          shareWechatnPic: true,
          sharePoster: Boolean(options.isOpenFaceShare),
          isShowErr: false,
          noShareWx: isXlUserApp() || lowXlVersionUserApp(),
          callback: target => {
            if (
              ['wechat1', 'wechatn'].indexOf(target) > -1 &&
              (isWeixinBrowser() || isWxMiniProgram())
            ) {
              shareTip({
                imgUrl: require(`../assets/images/share_tip.png`),
                width: '568px',
                top: '23px',
                right: '53px',
                duration: 5000
              });
              setTimeout(() => {
                resolve(target);
              }, 5000);
              return;
            }
            resolve(target);
          }
        });
      });
    }
  }
};
